<template>
  <li
    v-if="render && label"
    :class="$style.root"
  >
    {{ label }}
  </li>
</template>

<script setup>
const props = defineProps({
  indexUid: {
    type: String,
    required: true
  }
})

const render = computed(() => !props?.indexUid?.endsWith('-page') )
const label = getSearchLabel(props?.indexUid)

</script>

<style module>
.root {
  text-transform: uppercase;
}
</style>
